import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/ecommerce_web/ecommerce_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner ecomm_web_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Top E-Commerce Website Development Services in USA
              </h1>
              <span>Custom-Built, Conversion-Optimized Websites</span>
              <p style={{ marginTop: "10px" }}>
                Build mobile-ready, user-first shopping solutions with your
                favorite eCommerce store builders, including Shopify, Magento,
                WooCommerce, and BigCommerce. Our end-to-end eCommerce web
                development services help e-sellers design, develop, and launch
                responsive retail platforms. Gain extended customer reach,
                intuitive user engagement, and optimized conversion performance
                with custom eCommerce website development.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start with a Free Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
